// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HFN5","inner":"Footer_inner__21Hu4"};